import { API_URL_FACTORY } from '@factories/apiUrlFactory'
import logger from '@utils/logger'

type FetchPPEDProps = {
  regNo: string
}

export const fetchPPED = async ({
  regNo,
}: FetchPPEDProps): Promise<Record<string, unknown> | null> => {
  try {
    const response = await fetch(API_URL_FACTORY.PPED_API(regNo))

    if (!response.ok) {
      logger.error(`[Carbon Analytics Error log] HTTP error! status: ${response.status}`)
      return null
    }

    const data = await response.json()
    logger.info('data', data)
    return data
  } catch (e) {
    logger.error(`[Carbon Analytics Error log] error fetching PPED: ${e}`)
    return null
  }
}
